import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './index.css';
// Global typography is defined in index.css so native and shadcn-style UI stay aligned.
import { performanceMonitor } from './utils/performanceMonitor';

// Initialize performance monitoring
console.log('🚀 Performance monitoring initialized');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(<App />);
